<!-- 贺卡内容 -->
<template>
  <div class="greet-com">
    <img :src="greetImgMap.bgImg" class="bg" alt="" />
    <div class="content">
      <div class="happy-box">
        <img class="happy" :src="greetImgMap.happyImg" alt="" />
        <img class="day" :src="imgUrlMap.day" alt="" />
        <p class="name">{ TO: {{ userInfo.name }} }</p>
      </div>
      <div class="greet-box">
        <img
          v-if="userInfo.name === '徐春华'"
          :src="imgUrlMap.greet"
          class="boss-greet"
          alt=""
        />
        <div v-else class="greet">{{ greetStr }}</div>
      </div>
    </div>
    <div class="receive-btn" @click="receiveFun">领取专属福利</div>

    <!-- <van-icon name="replay" class="layout-btn" @click="signOutFun" /> -->

    <!-- 星星区域 -->
    <div class="start-region-box">
      <StarRegion :imgUrlMap="imgUrlMap" ref="starRegionRef" />
    </div>
  </div>
</template>
<script setup>

import { reactive, ref, computed, onBeforeMount, onMounted, defineProps, defineExpose, defineEmits, nextTick } from 'vue'
import { useRoute, useRouter, } from "vue-router";
import { useStore } from "vuex";
import { getSignInPages, } from '@/api/signInGift.js'
import { Toast } from 'vant';
import anime from 'animejs/lib/anime.es.js';
import StarRegion from './starRegion';
import { receive } from '@/api/womensDay'


const emit = defineEmits(["setProcess", 'receive']); //定义一个变量来接收父组件传来的方法

const route = useRoute();
const router = useRouter();
const store = useStore();

const props = defineProps({
  // 封面图片地址
  imgUrlMap: {
    type: Object,
    default: () => { }
  },
  userInfo: {
    type: Object,
    default: () => { }
  },
  process: {
    type: Number,
    default: undefined
  },
})

// 根据用户角色获取背景图片
const greetImgMap = computed(() => {
  const gender = props.userInfo.gender
  let imgMap = {
    bgImg: props.imgUrlMap['pic2'],
    happyImg: props.imgUrlMap['boy'],
  }
  if (gender === 0) {
    imgMap.bgImg = props.imgUrlMap['pic1']
    imgMap.happyImg = props.imgUrlMap['girl']
  }
  return imgMap
})

const starRegionRef = ref(null)
const greetStr = ref('')

onMounted(() => {
  // beginAnimation()
  // receiveFun()
});

// 领取
const receiveFun = () => {
  // emit('receive')
  // anime.remove('.receive-btn') // 取消按钮动画
  receive({}).then((res) => {
    if (res && res.code === 0) {
      emit('receive')
      anime.remove('.receive-btn') // 取消按钮动画
    }
  }).catch(res => {
    Toast(res.message)
  })
}
// 开启动画
const beginAnimation = () => {
  happyBoxFadeIn()
  setTimeout(() => {
    greetIn()
  }, 300)

}

// 顶部文字淡入
const happyBoxFadeIn = () => {
  anime({
    targets: ['.happy-box'],
    opacity: [0.1, 1],
    easing: 'easeInQuad',
    duration: 300,
    delay: 0
  })
}
// 祝福语动画
// 老板的祝福语图片淡入
// 其他的文字打印效果
const greetIn = () => {
  if (props.userInfo.name === '徐春华') {
    anime({
      targets: ['.boss-greet'],
      opacity: 1,
      easing: 'easeInQuad',
      duration: 300,
      delay: 200,
      complete: () => {
        receiveBtnFadesIn() // 按钮出现
      }
    })
  } else {
    greetPrint()
  }
}
// 祝福语打印
const greetPrint = () => {
  let str = props.userInfo.blessing
  let arr = str.split('\n')
  let arrSub = []
  arr.forEach(i => {
    let newArr = i.split('')
    newArr.push('\n')
    arrSub = arrSub.concat(newArr)
  })
  // 使用 anime.js 实现打字机效果
  anime({
    targets: arrSub,
    loop: false,
    duration: 3000,
    delay: anime.stagger(300),
    update: function (anim) {
      let index = Math.floor(anim.progress / 100 * arrSub.length)
      greetStr.value = arrSub.slice(0, index + 1).join('')
    },
    complete: () => {
      receiveBtnFadesIn() // 按钮出现

    }
  })
}

const signOutFun = () => {
  store.commit('signOut')
  location.reload()
}

// 领取按钮淡入  
const receiveBtnFadesIn = () => {
  anime({
    targets: ['.receive-btn'],
    opacity: 1,
    easing: 'easeInQuad',
    duration: 300,
    delay: 0,
    complete: () => {
      receiveBtnAnimation()
      gteetInitStartDate() // 星星出现
    }
  })
}
// 领取按钮默认动画 
const receiveBtnAnimation = () => {
  anime({
    targets: ['.receive-btn'],
    // pulse
    // keyframes: [
    //   { translateX: 1, translateY: 1, translateZ: 1, },
    //   { translateX: 1.05, translateY: 1.05, translateZ: 1.05, },
    //   { translateX: 1, translateY: 1, translateZ: 1, },
    // ],
    // headBeat
    keyframes: [
      { scale: 1 },
      { scale: 1.1 },
      { scale: 1 },
      { scale: 1.1 },
      { scale: 1 },

    ],
    easing: 'easeInOutSine',
    delay: 600,
    loop: true,
    duration: 600,
  })
}
// 星星数据数初始化
const gteetInitStartDate = () => {
  console.log('星星数据数初始化');

  starRegionRef.value.initStartDate(30)
}
// 星星消失
const gteetStartDisappear = () => {
  starRegionRef.value.startDisappear()
}


defineExpose({ beginAnimation })



</script>
<style  lang="less" scoped>
.greet-com {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  position: relative;
  .bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
  .content {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
  .happy-box {
    padding-right: 22px;
    text-align: right;
    opacity: 0;
    .happy {
      padding: 30px 0 10px 0;
      width: 328px;
      height: 63px;
    }
    .day {
      width: 106px;
      height: 59px;
    }
    .name {
      margin-top: 42px;
      font-weight: 600;
      font-size: 34px;
      color: #ffffff;
      line-height: 35px;
      font-family: cursive;
    }
  }
  .greet-box {
    margin-top: 30px;
    padding: 0 30px 0 46px;
    .boss-greet {
      opacity: 0;
      width: 160px;
    }
    .greet {
      font-size: 20px;
      font-weight: 600;
      color: #ffffff;
      line-height: 2;
      white-space: pre-line;
      // font-family: cursive;
    }
  }
  .receive-btn {
    position: absolute;
    bottom: 53px;
    left: 76px;
    opacity: 0;
    width: 220px;
    height: 46px;
    line-height: 46px;
    text-align: center;
    background: #000000;
    border-radius: 23px;
    font-weight: bold;
    font-size: 20px;
    color: #ffffff;
  }
  .start-region-box {
    position: absolute;
    top: 0px;
    width: 90%;
    height: 100vh;
    pointer-events: none;
  }
  .layout-btn {
    position: absolute;
    font-size: 20px;
    top: 10px;
    right: 10px;
    color: #fff;
  }
}
</style>
